import { render } from "./OnePackageSoftware.vue?vue&type=template&id=243cf5f2&scoped=true"
import script from "./OnePackageSoftware.vue?vue&type=script&lang=js"
export * from "./OnePackageSoftware.vue?vue&type=script&lang=js"

import "./OnePackageSoftware.vue?vue&type=style&index=0&id=243cf5f2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243cf5f2"]])

export default __exports__